import * as React from 'react';
import * as styles from '../styles/pageHeader.module.scss';
import ReactMarkdown from 'react-markdown';

function PageHeader({
  className,
  heading,
  description,
  background,
  children,
  focus,
}) {
  const hideBgOverlay = `.bg-secondary::before {
    visibility: hidden
  }`;

  return (
    <>
      <style>{hideBgOverlay}</style>
      <header
        className={`${styles.pageHeader} ${className}`}
        id='header'
        style={
          background
            ? {
                backgroundImage: `url(${background})`,
              }
            : focus
            ? {
                marginTop: 0,
              }
            : {}
        }
      >
        {!focus ? (
          <>
            <h1 className='center'>{heading}</h1>
            {description ? <ReactMarkdown>{description}</ReactMarkdown> : ''}
          </>
        ) : (
          ''
        )}
        {children ? <div>{children}</div> : ''}
      </header>
    </>
  );
}
export default PageHeader;
